import React from 'react';
import PropTypes from 'prop-types';

const CountertopRemovalOptionGroup = ({ children }) => children.length > 0 && (
  <div
    id="CountertopRemoval"
    data-template="CountertopRemovalOptionGroup"
    className="card-content flex-wrap-dependent-options"
  >
    <div className="row-header">
      <div className="row-header__title">
        <div className="sui-h2-bold sui-line-clamp-unset sui-text-primary">
          Removal Options
        </div>
      </div>
    </div>
    <div className="headless">{children}</div>
  </div>
);

CountertopRemovalOptionGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CountertopRemovalOptionGroup;
